export default {
  header: "My Cart Page",
  view: "Cart"
};
